import styled from 'styled-components';

export const StaffWrap = styled.div`
  padding: 10px;
  display: flex;
  flex-direction: column;
  max-width: 100%;
  flex: 1;
  gap: 8px;
`;
